
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.242 7.688L3.125.766h.922l6.57 5.593V3.117c0-.541-.036-.958-.11-1.25a1.331 1.331 0 00-.444-.695c-.224-.182-.51-.302-.86-.36v-.14l.274.023c.682.047 1.145.07 1.39.07.224 0 .758-.03 1.602-.093v.14c-.271.037-.508.149-.711.336a1.35 1.35 0 00-.406.657c-.073.265-.11.638-.11 1.117v4.765zm-9-6.922l9 7.687v.64h-.156L4.008 3.07v3.633c0 .792.101 1.341.304 1.649.204.307.524.507.961.601v.14A24.636 24.636 0 003.672 9c-.318 0-.797.031-1.438.094v-.14c.448-.105.753-.316.914-.634.162-.317.243-.88.243-1.687l-.008-4.078-.563-.477C2.04 1.411 1.38.99.844.813V.671l1.398.094z","fill":"currentColor"}})])
          )
        }
      }
    